// extracted by mini-css-extract-plugin
export default {"w-full":"Panel_w-full__H751O","panel":"Panel_panel__rq0pC","info":"Panel_info__gUhLE","btns":"Panel_btns__FjlTf","button":"Panel_button__owbG1"};